<template>
  <v-container justify-center>
    <ServicesForm :query="query" :busy="busy" />
  </v-container>
</template>

<script>
import ServicesForm from '@/components/ServicesForm'

export default {
  name: 'Services',
  components: {
    ServicesForm
  },
  props: {
    query: null
  },
  data() {
    return {
      busy: false
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.busy) {
      next()
    } else {
      next(false)
    }
  }
}
</script>
